import React from 'react'

import Draggable from 'react-draggable'

import ModalDialog from 'react-bootstrap/ModalDialog'

const draggableModalDialog = props =>(
	<Draggable cancel=".cancelDrag" handle=".modal-dialog">
		<ModalDialog {...props} />
	</Draggable>
)

export default draggableModalDialog